import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from "../../component/authanticationheader";

function TopupSuccess() {
    const navigate = useNavigate();
    const [transaction, setTransaction] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    
    useEffect(() => {
        const processTransaction = async () => {
            // Retrieve from currentTransaction sessionStorage
            const storedTransaction = sessionStorage.getItem('currentTransaction');
            
            if (storedTransaction) {
                const parsedTransaction = JSON.parse(storedTransaction);
                setTransaction(parsedTransaction);
                
                try {
                    const response = await axios.post(
                        `${apiUrl}/Transaction/AddTopupTransaction`, 
                        parsedTransaction
                    );
                    
                    if (response.status !== 201 && response.status !== 200) {
                        console.error('Failed to add transaction:', response.data);
                        navigate('/topupFailer');
                    }
                    // If status is 200/201, we stay on the success page
                } catch (error) {
                    console.error('Error adding transaction:', error);
                    navigate('/topupFailer');
                }
            } else {
                // No transaction found, maybe redirect to failure page
                navigate('/topupFailer');
            }
        };

        processTransaction();
    }, [apiUrl, navigate]);

    const handleGoToDashboard = () => {
        navigate('/dashboard');
    };

    return (
        <div className="App">
            <Header />
            <div>
                <section className="main-grid2 d-flex">
                    <div className="container">
                        <div className="row">
                            <div className="middle-sec2">
                                <img src="assets/images/flowers.png" alt="" />
                                <h2>Money added successfully!</h2>
                                <p>You have successfully purchased your Tannits. </p>
                            </div>
                            <div className="claim-last-sec2">
                                <button className="btn grn-btn3" onClick={handleGoToDashboard}>
                                    Go to dashboard <i className="fa-solid fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default TopupSuccess;